import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import FI from "../../assets/Fuel.png";

const FuelInjectionService = () => {
  return (
    <>
      <SeoHead
        title="Fuel Injection Service in Temecula | Advanced Automotive Smog"
        description="Fuel injector cleaning in Temecula to address rough idling, poor fuel economy, and slow acceleration caused by clogged injectors."
        path="/services/fuel-injection"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Fuel Injection Service"
          path="/services/fuel-injection"
          description="Fuel injector cleaning in Temecula to address rough idling, poor fuel economy, and slow acceleration caused by clogged injectors."
          serviceType="Fuel injection service"
        />

        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - mobile first */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={FI}
                alt="Fuel injector service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">

            {/* Tag */}
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Fuel System Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Fuel Injection Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Dirty or clogged fuel injectors can cause rough idling, poor
              fuel economy, slow acceleration, and reduced engine performance.
              Our fuel injection service restores smooth, efficient fuel
              delivery and improves the overall health of your engine.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Fuel Injection Service?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Fuel injectors deliver precise amounts of fuel into the engine.
              When they become clogged with carbon deposits, the engine no
              longer runs as efficiently.
              <br />
              <br />
              We use professional-grade equipment to clean the injectors,
              remove buildup, restore fuel spray patterns, and improve engine
              response and performance.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves fuel economy and throttle response</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Removes carbon buildup from fuel injectors</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps prevent long-term engine damage</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Reduces emissions and restores cleaner combustion</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Suitable for all gas and diesel vehicles</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>

            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default FuelInjectionService;

